import {
	useCallback,
	useState,
	useMemo
} from 'react';

const useToggle = ( initialState = false ) => {
	const [ state, setState ] = useState( initialState );

	const toggleState = useCallback( () => setState( prevState => !prevState ), [] );

	return useMemo( () => [
		state,
		toggleState,
		setState
	], [
		state,
		toggleState,
		setState
	] );
};

export default useToggle;
